import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import AttendeeListSubItem from 'components/attendee-list-sub-item'

import styles from './attendee-list-item.css'

const AttendeeListItem = ({ showCustomerData, email, name, phoneNumber, shared, ticketCount, ticketType }) => (
  <div styleName="attendee-list-item">
    <Relayout gutter={false}>
      <RelayoutItem sm="12" lg="4">
        <div styleName="name">
          {name}
          {showCustomerData && <div styleName="name-contact">{_.compact([email, phoneNumber]).join(' • ')}</div>}
        </div>
      </RelayoutItem>

      <RelayoutItem sm="9" lg="3">
        <div styleName="list-ticket-type">
          {ticketType.map((type, i) => <div styleName="ticket-type" key={i}>{type}</div>)}
        </div>
      </RelayoutItem>

      <RelayoutItem sm="3" lg="2">
        <div styleName="list-ticket-count">
          {ticketCount.map((count, i) => <div styleName="ticket-count" key={i}>{count}</div>)}
        </div>
      </RelayoutItem>

      {showCustomerData && <RelayoutItem sm="0" lg="3">
        <div styleName="contact">
          {email}
          {email && phoneNumber && <br />}
          {phoneNumber}
        </div>
      </RelayoutItem>}

      {shared &&
        <RelayoutItem sm="12">
          <div styleName="subitems">
            {shared.map((item, i) => <AttendeeListSubItem {...item} key={i} />)}
          </div>
        </RelayoutItem>
      }
    </Relayout>
  </div>
)

AttendeeListItem.propTypes = {
  showCustomerData: PropTypes.bool,
  email: PropTypes.string,
  name: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string,
  shared: PropTypes.array,
  ticketCount: PropTypes.array.isRequired,
  ticketType: PropTypes.array.isRequired,
}

export default CSSModules(AttendeeListItem, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/attendee-list-item/attendee-list-item.js
 **/